var map = {
	"./1.png": 46,
	"./10.png": 4476,
	"./2.png": 2469,
	"./3.png": 4956,
	"./4.png": 4915,
	"./5.png": 4154,
	"./6.png": 3137,
	"./7.png": 4072,
	"./8.png": 2079,
	"./9.png": 6982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9252;